<template>
  <div
    :id="`${source}_custom_date_time_filter`"
    class="flex flex-col gap-2 font-normal proxima_nova"
  >
    <span v-if="text" class="text-[13px] secondary_color">{{ text }}</span>

    <div
      class="flex"
      :class="[
        {
          'flex-col': direction === customSelectorDirections.VERTICAL,
          'flex-row': direction === customSelectorDirections.HORIZONTAL,
        },
      ]"
      :style="{ gap: `${gap}px` }"
    >
      <div :id="`${source}_custom_date`" class="flex flex-col gap-2 w-full">
        <span class="text-[13px] secondary_color">Date</span>

        <a-date-picker
          :value="startDate"
          @update:value="$emit('update:startDate', $event)"
          :format="format"
          class="w-full"
          :allowClear="false"
          placeholder="Select date"
        />
      </div>

      <div :id="`${source}_custom_time`" class="flex flex-col gap-2 w-full">
        <span class="text-[13px] secondary_color">Time</span>

        <a-select
          :value="endDate"
          @update:value="$emit('update:endDate', $event)"
          showSearch
          class="w-full"
          placeholder="Select time"
        >
          <template #suffixIcon>
            <ThemeImage
              :icon="imageNames.BOTTOM_ARROW"
              alt="bottom_white_arrow"
              class="size-4"
            />
          </template>
          <a-select-option
            v-for="(time, index) in timeIntervals"
            :key="`${time}_${source}_${index}`"
            :value="time"
          >
            {{ time }}
          </a-select-option>
        </a-select>
      </div>
    </div>
  </div>
</template>

<script setup>
import { imageNames } from "@/src/constants/imageConstants.js";
import { customSelectorDirections } from "@/src/constants/customComponentConstants.js";
import { dateTimeFormats } from "@/src/constants/dateTimeConstants.js";
import { generateTimeOptions } from "@/src/utils/utils.js";

const props = defineProps({
  source: { type: String, required: true },
  text: { type: String, default: "" },
  parentFormat: { type: String, default: dateTimeFormats[3] },
  startDate: { type: [String, Object], default: null },
  endDate: { type: [String, Object], default: null },
  direction: {
    type: String,
    default: customSelectorDirections.HORIZONTAL,
    validator: (value) =>
      Object.values(customSelectorDirections).includes(value),
  },
  format: { type: String, default: "DD/MM/YY" },
  gap: { type: [String, Number], default: "8" },
});

const emit = defineEmits(["update:startDate", "update:endDate"]);

const timeIntervals = generateTimeOptions();
</script>
